import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import {LocalisationService} from '../localisation.service';
import {TranslationService} from '../../../services/translation.service';
import {LocalisationInfoItemInterface} from '../../../../class/api/LocalisationInfoItem';
import {MatDialog} from '@angular/material/dialog';
import {ModalConfirmationComponent} from '../../modal-confirmation/modal-confirmation.component';
import {Subscription} from 'rxjs';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import {LocalisationMetastase} from '../../../../class/api/LocalisationMetastase';

import { MatSelect } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
    selector: 'app-localisation-cancer',
    templateUrl: './localisation-cancer.component.html',
    styleUrls: ['./localisation-cancer.component.scss'],
    providers: [TranslationService],
    imports: [MatSelect, FormsModule, MatOption, MatCheckbox, TranslateModule]
})
export class LocalisationCancerComponent implements OnInit, AfterViewInit {
    locService = inject(LocalisationService);
    translationService = inject(TranslationService);
    ngxTranslateService = inject(TranslateService);
    matDialog = inject(MatDialog);

    // null => level 1, null => level 2, null => level 3, false => choice metastases
    public localisationSelected = [null, null, null, false] as any;
    public customValue = '';
    private subscriptions: Subscription[] = [];

    public selected = []; // ID_XXXX

    public search = '';

    constructor() {
        this.localisationSelected = [null, null, null, false] as any;
        this.getTranslations();
    }

    public cancer: LocalisationInfoItemInterface = null;
    public cancerIndex: number = null;
    private messageAnnuler = 'general.annuler';
    private messageConfirmer = 'general.confirmer';
    private messageTexteChangeCancer = 'front.dossiers.fieldGenerator.localisation.texteChangeCancer';

    @Input() set passCancerIndex(index: number) {
        this.cancer = this.locService.localisationInfo.cancerPrimitifs[index];
        this.cancerIndex = index;

        this.cancer.localisationMetastases.forEach((item: LocalisationMetastase) => {
            this.selected['ID__' + item.id] = true;
        });
    }

    @Output() removeCancerEvent: EventEmitter<boolean> = new EventEmitter();

    public getTranslations() {
        this.subscriptions.push(this.ngxTranslateService.get(this.messageAnnuler).subscribe(res => this.messageAnnuler = res));
        this.subscriptions.push(this.ngxTranslateService.get(this.messageConfirmer).subscribe(res => this.messageConfirmer = res));
        this.subscriptions.push(this.ngxTranslateService.get(this.messageTexteChangeCancer).subscribe(res => this.messageTexteChangeCancer = res));
    }

    public getLocInLocList(id, list: any[]) {
        let loc = null;
        for (let i = 0; i < list.length; i++) {
            const item = list[i];
            if (loc == null) {
                if (item['id'] == id) {
                    loc = item;
                } else {
                    if (item['children'] != null && item['children'].length) {
                        loc = this.getLocInLocList(id, item['children']);
                    }
                }
            } else {
                return loc;
            }
        }
        return loc;
    }

    public addMetastases() {
        for (const index in this.selected) {
            const id = +index.replace('ID__', '');
            let metaAlreadyExist = false;
            // On test si l'item demandé en ajout existe déjà dans ceux séléctionné
            this.cancer.localisationMetastases.map((item: LocalisationMetastase) => {
                if (item.id == id) {
                    metaAlreadyExist = true;
                }
            });
            // N'existe pas.
            if (!metaAlreadyExist) {
                // Récupération de la méta complete
                const meta = this.getLocInLocList(
                    id,
                    this.locService.localisations
                );
                if (meta != null) {
                    this.cancer.localisationMetastases.push(meta);
                }
            }
        }

        this.cancer.localisationMetastases.map((item: LocalisationMetastase, index) => {
            let metaNotExist = true;
            for (const indexSelected in this.selected) {
                const id = indexSelected.replace('ID__', '');
                if (+item['id'] === +id) {
                    metaNotExist = false;
                }
            }

            if (metaNotExist) {
                this.cancer.localisationMetastases.splice(index, 1);
            }
        });
        this.locService.setCancer(this.cancer, this.cancerIndex);
    }

    selectLoc(meta: LocalisationMetastase, addOrDelete: boolean) {
        if (!addOrDelete) {
            this.cancer.localisationMetastases = this.cancer.localisationMetastases.filter(item => item.id != meta.id);
        } else {
            this.cancer.localisationMetastases.push(meta);
        }
        this.locService.setCancer(this.cancer, this.cancerIndex);

    }

    public supprimer(index: number) {
        const elemSup = this.cancer.localisationMetastases.splice(index, 1);
        delete this.selected['ID__' + elemSup[0].id];
        this.locService.setCancer(this.cancer, this.cancerIndex);
    }

    public changeCancerType(event: boolean) {
        if (this.cancer.localisationMetastases.length) {
            const dialog = this.matDialog.open(ModalConfirmationComponent, {
                data: {
                    confirm: this.messageConfirmer,
                    cancel: this.messageAnnuler,
                    content: this.messageTexteChangeCancer,
                },
            });

            dialog.afterClosed().subscribe(res => {
                if (res != null && res) {
                    this.localisationSelected[3] = event;
                    this.cancer.localisationMetastases = [];
                    this.locService.setCancer(this.cancer, this.cancerIndex);
                } else {
                    this.localisationSelected[3] = !event;
                }
            });
        }
    }

    public updateSelect($event, index) {
        if ($event != null) {
            this.updateCancerCourant('select');
        }
        switch (index) {
            case 0:
                this.localisationSelected[1] = null;
                this.localisationSelected[2] = null;
                break;
            case 1:
                this.localisationSelected[2] = null;
                break;
            case 2:
                break;
        }
    }

    public compareByIri(x, y) {
        if (x == null && y == null) {
            return true;
        } else {
            return (
                x != null &&
                y != null &&
                x['@id'] != undefined &&
                y['@id'] != undefined &&
                x['@id'] == y['@id']
            );
        }
    }

    public displayCustomValue() {
        if (
            this.localisationSelected[0] != undefined &&
            this.localisationSelected[0] != null &&
            this.localisationSelected[0]['champSaisieLibre'] == true
        ) {
            return true;
        }

        if (
            this.localisationSelected[0] != undefined &&
            this.localisationSelected[1] != undefined &&
            this.localisationSelected[0] != null &&
            this.localisationSelected[1] != null &&
            this.localisationSelected[1]['champSaisieLibre'] == true
        ) {
            return true;
        }

        if (
            this.localisationSelected[0] != undefined &&
            this.localisationSelected[1] != undefined &&
            this.localisationSelected[2] != undefined &&
            this.localisationSelected[0] != null &&
            this.localisationSelected[1] != null &&
            this.localisationSelected[2] != null &&
            this.localisationSelected[2]['champSaisieLibre'] == true
        ) {
            return true;
        }

        return false;
    }

    private _timeout: any = null;

    updateCancerCourant(action: string) {
        if (this._timeout != null) {window.clearTimeout(this._timeout);}
        this._timeout = window.setTimeout(() => {
            switch (action) {
                case 'precision':
                    this.locService.setCancer(this.cancer, this.cancerIndex);
                    break;
                case 'select': // Mise à jour du cancer par celui séléctionné
                    this.cancer.precisionLocalisation = '';

                    // this.locService.setCancer(this.cancer, this.cancerIndex);
                    //Si j'ai une loc 0 et pas d'enfant
                    if (
                        this.localisationSelected[0] != null &&
                        !this.getLocalisationChoices(this.localisationSelected[0]['children']).length
                    ) {
                        this.cancer.localisation = this.localisationSelected[0];
                        this.locService.setCancer(
                            this.cancer,
                            this.cancerIndex
                        );
                    } else {
                        //Si j'ai une loc 1 et pas d'enfant
                        if (
                            this.localisationSelected[1] != null &&
                            !this.getLocalisationChoices(this.localisationSelected[1]['children']).length
                        ) {
                            this.cancer.localisation = this.localisationSelected[1];
                            this.locService.setCancer(
                                this.cancer,
                                this.cancerIndex
                            );
                        } else {
                            //Si j'ai une loc 3
                            if (this.localisationSelected[2] != null) {
                                this.cancer.localisation = this.localisationSelected[2];
                                this.locService.setCancer(
                                    this.cancer,
                                    this.cancerIndex
                                );
                            }
                        }
                    }
                    break;
                case 'customValue':
                    // Mise à jour du cancer avec la precision
                    if (
                        this.cancer.localisation != null &&
                        this.cancer.localisation['champSaisieLibre'] == true
                    )
                        {this.cancer.precisionLocalisation = this.customValue;}
                    this.locService.setCancer(this.cancer, this.cancerIndex);

                    break;
            }
        }, 500);
    }

    removeCancer() {
        this.removeCancerEvent.emit(true);
    }

    ngAfterViewInit() {
        if (this.cancer.localisationMetastases.length) {
            this.localisationSelected[3] = true;
        }
    }

    ngOnInit() {
        if (this.cancer != null && this.cancer.localisation != null) {
            this.locService.localisations.map(loc1 => {
                if (loc1['id'] == this.cancer['localisation']['id']) {
                    this.localisationSelected[0] = loc1;
                } else {
                    if (loc1['children'].length) {
                        loc1.children.map(loc2 => {
                            if (
                                loc2['id'] == this.cancer['localisation']['id']
                            ) {
                                this.localisationSelected[1] = loc2;
                                this.localisationSelected[0] = loc1;
                            } else {
                                if (loc2['children'].length) {
                                    loc2.children.map(loc3 => {
                                        if (
                                            loc3['id'] ==
                                            this.cancer['localisation']['id']
                                        ) {
                                            this.localisationSelected[2] = loc3;
                                            this.localisationSelected[1] = loc2;
                                            this.localisationSelected[0] = loc1;
                                        }
                                    });
                                }
                            }
                        });
                    }
                }
            });
            if (this.cancer.localisationMetastases.length) {
                this.localisationSelected[3] = true;
            } else {
                this.localisationSelected[3] = false;
            }

            this.customValue = this.cancer.precisionLocalisation;
        }
    }

    public getLocalisationChoices(parentLocalisation) {
        return parentLocalisation.filter(child => child.enabled === true);
    }

}
